import { inRn } from 'lib/helpers/utility';

export const getNetSurcharge = (transaction) =>
  Math.max(inRn(transaction?.surcharge_amount) - inRn(transaction?.surcharge_refunded), 0);

export const getNetGratuity = (transaction) =>
  Math.max(inRn(transaction?.gratuity) - inRn(transaction?.gratuity_refunded), 0);

export const getAmountPaid = (transaction) =>
  inRn(transaction?.amount_paid_self) - getNetSurcharge(transaction) - getNetGratuity(transaction);

export const getSaleAmount = (transaction) =>
  getAmountPaid(transaction) + inRn(transaction?.amount_refunded);
